export const ROUTE_URL = {
  vehiclesSelection: '/vehicles/selection',
  home: '/epc',
  customerBase: '/pos/customers',
  login: '/login',
  resetPasword: '/reset-password',
};

export const LISTS_FOR_CUSTOMERS = [
  'branchLookup',
  'countryLookup',
  'stateLookup',
  'zoneLookup',
  'routeLookup',
  'freightLookup',
  'colourLookup',
  'carrierLookup',
  'phoneTypeLookup',
  'vehicleRetiredReasonLookup',
];

export const LISTS_FOR_ORDERS = ['branchLookup', 'orderTypeLookup', 'productGroup', 'customerChannelLookup'];

export const LISTS_FOR_MANAGED_USERS = [
  'branchLookup',
  'orderTypeLookup',
  'inventoryViewLookup',
  'fetchPartnerProgrammes',
  'countryLookup',
  'stateLookup',
  'zoneLookup',
  'routeLookup',
  'freightLookup',
  'colourLookup',
  'carrierLookup',
];

export const API_ENDPOINTS = {
  stateLookup: '/lists/state',
  countryLookup: '/lists/country',
  countryExternaLookup: '/lists/CountryExternal',
  branchLookup: '/lists/branch',
  zoneLookup: '/lists/zone',
  routeLookup: '/lists/route',
  freightLookup: '/lists/FreightHandling',
  colourLookup: '/lists/colours',
  carrierLookup: '/lists/carrier',
  phoneTypeLookup: '/lists/PhoneType',
  vehicleRetiredReasonLookup: '/lists/VehicleRetiredReason',
  attachmentUpload: '/api/attachments/',
  vehicleSearch: '/vehicle/FetchHierarchy',
  customerSearch: '/customer/search',
  fetchCustomerDetails: '/customer/FetchCustomerDetails',
  duplicateCustomerSearch: '/customer/DuplicateCustomerSearch',
  getCustomerDetailsExternal: '/sellarb/CustomerDetailsExternal',
  createRetailCustomer: '/customer/CreateCashCustomer',
  updateRetailCustomer: '/customer/UpdateCashCustomer',
  updateShipToCustomer: '/customer/UpdateShipToCustomer',
  createShipToCustomer: '/customer/CreateShipToCustomer',
  getCustomerVehicles: '/customer/FetchVehicleList',
  maintainCustomerVehicle: '/customer/MaintainVehicle',
  login: '/user/login',
  loginV2: '/user/LoginV2',
  resetPasword: '/user/ResetUserPassword',
  forgottenPassword: '/user/ForgottenPassword',
  registerExternalUserPublic: '/user/RegisterExternalUserPublic',
  logout: '/user/logout',
  logoutV2: '/user/LogoutV2',
  orderTypeLookup: '/lists/OrderType',
  inventoryViewLookup: '/lists/InventoryView',
  customerChannelLookup: '/lists/CustomerChannel',
  productGroup: '/lists/ProductGroup',
  enteredBy: '/lists/EnteredBy',
  orderSummary: '/sales/OrderSummary',
  orderSummaryOpenOrders: '/sales/OrderSummaryOpenOrders',
  orderSummaryQuoteOrders: '/sales/OrderSummaryQuoteOrders',
  generateQuoteForNonCorp: '/asyncOrder/GenerateQuoteForNonCorp',
  orderSummaryInvoicedOrders: '/sales/OrderSummaryInvoicedOrders',
  getPartDetails: '/sales/PartDetails',
  searchItems: '/item/ItemSearch',
  fetchJDEUsers: '/user/FetchJDEUsers',
  fetchJDESingleUser: '/user/FetchJDESingleUser',
  fetchRegisteredUsers: '/user/FetchRegisteredUsers',
  setJDEUserSecurity: '/user/SetJDEUserSecurity',
  setUserSecurity: '/user/SetUserSecurity',
  fetchSecurityFunctions: '/lists/FetchSecurityFunctionList',
  JDEPrinters: '/lists/JDEPrinters',
  fetchDefaultVehicle: '/vehicle/FetchDefaultVehicle',
  createOrder: '/staging/CreateOrder',
  fetchCustomerShipTo: '/customer/FetchCustomerShipTo',
  fetchCustomerBillTo: '/customer/FetchCustomerBillTo',
  fetchUserState: '/userState/FetchUserState',
  fetchOrderHeader: '/staging/FetchOrderHeader',
  addItemToOrder: '/staging/AddItemToOrder',
  validateItemForOrder: '/staging/ValidateItemForOrder',
  fetchOrderDetails: '/staging/FetchOrderDetails',
  fetchUpdatedOrderLine: '/staging/FetchUpdatedOrderLine',
  removeItemFromOrder: '/staging/RemoveItemFromOrder',
  updateItemOnOrder: '/staging/UpdateItemOnOrder',
  updateAllItemsOnOrder: '/staging/UpdateAllItemsOnOrder',
  updateOrderHeader: '/staging/UpdateOrderHeader',
  unloadOrder: '/staging/UnloadOrder',
  insertLineAfter: '/staging/InsertLineAfter',
  reSequenceLines: '/staging/ReSequenceLines',
  fetchItemAvailability: '/item/FetchItemAvailability',
  checkBuyinItem: '/item/CheckBuyinItem',
  validateOrderInJDE: '/staging/ValidateOrderInJDE',
  toggleShowroomView: '/userState/ToggleShowroomView',
  toggleXRefPartsView: '/userState/ToggleXrefPartsView ',
  updateSelectedVehicle: '/userState/UpdateSelectedVehicle',
  distributeOrder: '/order/DistributeOrder',
  updateAccountCustomerSettings: '/customer/UpdateAccountCustomerSettings',
  updateCustomerEmail: '/customer/UpdateCustomerEmail',
  fetchOrderFromJDE: '/order/FetchOrderFromJDE',
  checkLineStockAllocation: '/item/CheckLineStockAllocation',
  checkStockAllocation: '/item/CheckStockAllocation',
  adjustStockAllocation: '/item/adjustStockAllocation',
  fetchCashCustomer: '/customer/FetchCashCustomer',
  fetchPayments: '/lists/FetchPayments',
  fetchPaymentInfo: '/order/fetchPaymentInfo',
  fetchInvoicePayments: '/sellarb/FetchInvoicePayments',
  getPaymentTypes: '/lists/PaymentTypes',
  givexGetBalance: '/givex/GivexGetBalance',
  givexActivation: '/givex/GivexActivation',
  redeemCard: '/givex/GivexRedemption',
  savePayment: '/staging/SavePayments',
  getRegisterList: '/lists/ListRegisters',
  getCreditReasonList: '/lists/ListReasonCodes',
  getSupplierList: '/lists/ListSuppliers',
  fetchCrossDock: '/item/FetchCrossDock',
  fetchDetailedInventory: '/item/FetchDetailedInventory',
  fetchInboundDetails: '/item/FetchInboundDetails',
  checkUserForCredits: '/user/CheckUserForCredits',
  fetchCashRoundedAmount: '/order/FetchCashRoundedAmount',
  fetchRegisterForHost: '/registers/FetchRegisterForHost',
  setRegisterForHost: '/registers/SetRegisterForHost',
  openCloseRegiser: '/registers/OpenCloseRegister',
  getFeedbackTypes: '/api/feedback/types',
  searchSuppliers: '/supplier/SupplierSearch',
  getCustomerSales: '/customer/CustomerSalesFigures',
  getStatementList: '/sellarb/StatementListExternal',
  getInvoiceList: '/sellarb/InvoiceListExternal',
  createCreditOrder: '/staging/CreateCreditOrder',
  emailStatementExternal: '/sellarb/EmailStatementExternal',
  emailInvoiceReprintExternal: '/sellarb/EmailInvoiceReprintExternal',
  copyOrder: '/staging/CopyOrder',
  fetchRecentOrders: '/order/FetchRecentOrders',
  fetchCatalogueStatus: '/user/FetchCatalogueStatus',
  checkSerialNumberOnHand: '/item/CheckSerialNumberOnHand',
  checkPreviousCredit: '/order/CheckPreviousCredit',
  submitWarranty: '/warranty/SubmitWarranty',
  getWarrantyFaultList: '/lists/ListWarrantyFaultCodes',
  getShowList: '/show/FetchShowList',
  getExternalUserList: '/lists/FetchExternalUsers',
  createShowCode: '/show/CreateShowCode',
  createShowUser: '/show/CreateShowUser',
  loginToShow: '/show/LoginToShow',
  loginToProgramme: '/user/LoginToProgramme',
  getShowUsers: '/show/FetchShowUsers',
  deleteShowCode: '/show/RemoveShowCode',
  fetchNonCorpStoresForShow: '/show/FetchNonCorpStoresForShow',
  checkForShowSales: '/show/CheckForShowSales',
  fetchCustomerShowList: '/show/FetchCustomerShowList',
  fetchShowSalesForExternal: '/show/FetchShowSalesForExternal',
  fetchShowPrinters: '/show/FetchShowPrinters',
  fetchUsersForRecentOrders: '/lists/FetchUsersForRecentOrders',
  savePendingPayments: '/staging/SavePendingPayments',
  removePendingPayment: '/staging/RemovePendingPayments',
  updatePendingPayment: '/staging/UpdatePendingPayments',
  orderLevelReprice: '/order/OrderLevelReprice',
  resetOrderPrice: '/order/ResetOrderPrice',
  fetchBranchInvoiceDetails: '/lists/FetchBranchInvoiceDetails',
  fetchNextNumber: '/order/FetchNextNumber',
  finaliseOrderToJDE: '/asyncOrder/AsyncOrderToJDE',
  fetchBrandDefaults: '/lists/FetchBrandDefaults',
  listTasksNotes: '/crm/ListTasksNotes',
  updateNotes: '/crm/UpdateNotes',
  updateTasks: '/crm/UpdateToDo',
  updateAlert: '/crm/UpdateAlert',
  getCustomerAlert: '/crm/getCustomerAlert',
  listTemplates: '/crm/ListTemplates',
  listOutcomes: '/crm/ListOutcomes',
  completeTask: '/crm/CompleteTask',
  fetchCRMUsers: '/crm/FetchCRMUsers',
  fetchGiftCardLoad: '/staging/FetchGiftCardLoad',
  addGiftCardLoad: '/staging/AddGiftCardLoad',
  assignEftposDeviceToHost: '/eftpos/AssignEFTPOSDeviceToHost',
  registerEftpos: '/api/eftpos/register',
  checkEftposStatus: '/api/eftpos/status',
  makeEftposTransaction: '/api/eftpos/transaction',
  fetchVehicleDescription: '/vehicle/FetchVehicleDescription',
  fetchShipTos: '/customer/FetchShipTos',
  listHoldCode: '/lists/ListHoldCodes',
  releaseHoldCode: '/order/ReleaseOrderHoldCode',
  fetchContentStructure: '/ContentComponent/FetchContentStructure',
  downloadFile: '/ContentComponent/DownloadFile',
  fetchSpotLightInfo: '/ContentComponent/FetchSpotLightInfo',
  fetchParkedOrderList: '/parkOrder/FetchParkedOrderList',
  loadParkedOrder: '/parkOrder/LoadParkedOrder',
  removeParkedOrder: '/parkOrder/RemoveParkedOrder',
  removeAllParkedOrders: '/parkOrder/RemoveAllParkedOrders',
  fetchWeekList: '/WorkshopBooking/FetchWeekList',
  fetchResourceList: '/WorkshopBooking/FetchResourceList',
  fetchOrdersForBooking: '/WorkshopBooking/FetchOrdersForBooking',
  changeOrderBooking: '/WorkshopBooking/changeOrderBooking',
  splitOrder: '/WorkshopBooking/SplitOrder',
  consolidateOrder: '/WorkshopBooking/ConsolidateOrderV2',
  renameGroupName: '/WorkshopBooking/RenameGroupName',
  reassignLine: '/WorkshopBooking/ReassignLine',
  resourceFuzzySearch: '/WorkshopBooking/ResourceFuzzySearch',
  fetchResourceById: '/WorkshopBooking/FetchResourceByID',
  reprintReceipt: '/eftpos/reprintReceipt',
  trailerSearch: '/trailer/TrailerSearch',
  fetchCustomerTrailerDetails: '/trailer/FetchCustomerTrailerDetails',
  updateTrailerInfo: '/trailer/UpdateTrailerInfo',
  fetchRegoStatus: '/lists/RegoStatus',
  updateServiceHistory: '/trailer/UpdateServiceHistory',
  fetchStoreList: '/trailer/StoreList',
  camperTrailerGenerateReport: '/trailer/GenerateReport',
  fetchARBuCohorts: '/lists/ARBuCohorts',
  customerSpecificSearch: '/customer/customerSpecificSearch',
  createOrderSilent: '/staging/CreateOrderSilent',
  fetchItemPriceGroup: '/item/FetchItemPriceGroup',
  postcodes: '/lists/PostCodes',
  fetchRecordsForBooking: '/WorkshopBooking/FetchRecordsForBooking',
  listWorkshopTask: '/lists/ListWorkshopTasks',
  maintainTaskBooking: '/WorkshopBooking/MaintainTaskBooking',
  maintainOrderBooking: '/WorkshopBooking/MaintainOrderBooking',
  fetchWorkshopHours: '/WorkshopBooking/FetchWorkshopHours',
  fetchScheduledResources: '/WorkshopBooking/FetchScheduledResources',
  listWorkshopOrderStatus: '/lists/ListWorkshopOrderStatus',
  changeResourceDescription: '/WorkshopBooking/ChangeResourceDescription',
  fetchResourceHours: '/WorkshopBooking/FetchResourceHours',
  changeResourceSchedule: '/WorkshopBooking/ChangeResourceSchedule',
  fetchResourceListV2: '/WorkshopBooking/FetchResourceListV2',
  addResourceToSchedule: '/WorkshopBooking/AddResourceToSchedule',
  findSalesOrderInSchedule: '/WorkshopBooking/FindSalesOrderInSchedule',
  removeResourceFromSchedule: '/WorkshopBooking/RemoveResourceFromSchedule',
  fetchOrderDetailsForSplit: '/WorkshopBooking/FetchOrderDetailsForSplit',
  splitOrderV2: '/WorkshopBooking/splitOrderV2',
  consolidateOrderV2: '/WorkshopBooking/ConsolidateOrderV2',
  fetchMonthlyViewForOrder: '/WorkshopBooking/FetchMonthlyViewForOrder',
  listWorkshopVehicleStatus: '/lists/ListWorkshopVehicleStatus',
  listWorkshopJobTypes: '/lists/ListWorkshopJobTypes',
  sendSMSReminderBeforeBooking: '/WorkshopBooking/SendSMSReminderBeforeBooking',
  listWorkshopLegend: '/lists/ListWorkshopLegend',
  sendSMSCollectCar: '/WorkshopBooking/SendSMSCollectCar',
  fetchWorkshopOpenDays: '/WorkshopBooking/FetchWorkshopOpenDays',
  changeWorkshopOpenDays: '/WorkshopBooking/ChangeWorkshopOpenDays',
  fetchOrderDetailsForScheduler: '/WorkshopBooking/FetchOrderDetails',
  fetchOrderLedger: '/WorkshopBooking/FetchOrderLedger',
  fetchRecordsForWeek: '/WorkshopBooking/FetchRecordsForWeek',
  removeOrderFromSchedule: '/WorkshopBooking/RemoveOrderFromSchedule',
  changeWorkshopTimes: '/WorkshopBooking/ChangeWorkshopTimes',
  fetchPartnerProgrammes: '/lists/FetchPartnerProgrammes',
  externalUserSearch: '/user/SearchExternalUser',
  updatePartnerProgramme: '/customer/updatePartnerProgramme ',
  createPartnerProgramme: '/customer/createPartnerProgramme',
  listFitLocations: '/lists/fitLocations',
  fetchOrderTotals: '/order/FetchOrderTotals',
  fetchOpenQuotesOrders: '/order/FetchOpenQuotes',
  fetchOpenARBOrders: '/order/FetchOpenARBOrders',
  updateRequestDateOfSavedOrder: '/order/UpdateRequestDateOfSavedOrder',
  fetchPartnerProgrammeDetails: '/customer/FetchPartnerProgrammeDetails',
  fetchGenericCustomer: '/staging/FetchGenericCustomer',
  fetchOpenJobRequests: '/order/FetchOpenJobRequests',
  updateOwnerOfSavedOrder: '/order/UpdateOwnerOfSavedOrder',
  fetchPIBEmailList: '/ARBCentral/FetchPIBEmailList',
  fetchPIBEmailDetails: '/ARBCentral/FetchPIBEmailDetails',
  fetchInternalEmailList: '/ARBCentral/FetchInternalEmailList',
  deletePIBEmail: '/ARBCentral/RemovePIBEmail',
  listCommunicationGroups: '/lists/ListCommunicationGroups',
  uploadPIBEmail: '/ARBCentral/UploadEmail',
  fetchMyHelpComponent: '/ARBCentral/FetchMyHelpComponent',
  listTasks: '/crmLite/ListTickets',
  maintainTask: '/crmLite/MaintainTicket',
  fetchTaskDetail: '/crmLite/FetchTicketDetail',
  checkOrderExist: '/crmLite/CheckOrderExists',
  fetchSiteList: '/crmLite/FetchSiteList',
  addTaskComment: '/crmLite/AddTicketComment',
  updateTaskComment: '/crmLite/UpdateTicketComment',
  deleteTaskComment: '/crmLite/DeleteTicketComment',
  fetchTaskSummary: '/crmLite/FetchTicketSummary',
  acknowledgeTaskUpdate: '/crmLite/AcknowledgeTicketUpdate',
  closeTask: '/crmLite/CloseTicket',
  reopenTask: '/crmLite/ReopenTicket',
  fetchSalesPeople: '/user/FetchSalesPeople',
  changeARBCentralBarSetting: '/userState/ChangeARBCentralBarSetting',
  fetchARBCentralNavSecuritySettings: '/ARBCentral/ARBCentralSecurity',
  loadAttachmentForOrder: '/order/LoadAttachmentForOrder',
  unloadAttachmentForOrder: '/order/UnloadAttachmentForOrder',
  saveAttachmentForOrder: '/order/SaveAttachmentForOrder',
  fetchTaskTotals: '/crmLite/FetchTicketTotals',
  fetchUserSite: '/lists/FetchUserSite',
  switchSite: '/user/SwitchSite',
  fetchAllHelpComponents: '/ARBCentral/FetchAllHelpComponents',
  addHelpComponent: '/ARBCentral/AddHelpComponent',
  updateHelpComponent: '/ARBCentral/MaintainHelpComponent ',
  removeHelpComponent: '/ARBCentral/RemoveHelpComponent',
  fetchHelpComponentRoles: '/lists/HelpComponentRoles',
  impersonatePartner: '/user/SwitchSite',
  fetchPriceScaleCodeList: '/lists/PriceScales',
  customerShipToSearch: '/customer/ShipToSearch',
  fetchOpenClickAndCollect : '/order/FetchOpenClickAndCollect',
  fetchOpenFLAOrders: '/order/FetchOpenFLAOrders',
  fetchOpenEcomQuotes: '/order/FetchOpenEcomQuotes',
  fetchOpenJobRequestTotals: '/order/FetchOpenJobRequestTotals',
  acknowledgeEcomOrder: '/order/AcknowledgeEcomOrder',
  printPickSlipClickAndCollect: '/order/PrintPickSlipClickAndCollect',
  notifyCustomerClickAndCollect: '/order/NotifyCustomerClickAndCollect',
  loadShipToFromJDE: '/customer/LoadShipTosOnPartnerRecord',
  fetchVehiclePromotionsByRego: '/vehicle/FetchVehiclePromotionsByRego',
  maintainVehiclePromotionByCustomerVehicle: '/vehicle/MaintainVehiclePromotionByCustomerVehicle',
  vehiclePromotions: '/lists/VehiclePromotions',
  asyncJobRequestNonCorpToJDE: '/asyncOrder/AsyncJobRequestNonCorpToJDE',
  submitIdentityForCollection: '/order/ConfirmIdentityForCollection',
  fetchShowOrdersAndQuotes: '/show/FetchShowOrdersAndQuotes',
  fetchCustomerVehicle: '/customer/FetchCustomerVehicle',
  jobOrderSearch: '/workshopBooking/JobFuzzySearch',
  globalEcomSearch: '/order/GlobalEcomSearch',
  clickAndCollectStatus: '/lists/ClickAndCollectStatus',

  // DMS API
  getResources: '/resources',
  getDownloadUrl: '/downloadUrl',
};

export const KEYS = {
  jdeSession: 'jdeSession',
  jdeToken: 'jde-token',
  cashDrawer: 'cashDrawer',
  version: 'version',
  catalogueStatus: 'catalogueStatus',
};

